class IfQuiz {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.popup = section.querySelector('.if-quiz-slider-wrap-popup');
    this.openTriggers = section.querySelectorAll('.if-quiz-open-trigger, .if-quiz-button');
    this.startBtn = section.querySelector('.if-start-quiz');
    this.closeBtn = section.querySelector('.if-popup-close');
    this.topbarBack = section.querySelector('.if-quiz-topbar-back');
    this.slides = section.querySelectorAll('.if-quiz-inner-slide-main');
    this.resultsScroll = section.querySelector('.if-quiz-results-lelo__scroll');
    this.resultsFeatured = section.querySelector('.if-quiz-results-lelo__featured');
    this.matchedProducts = [];

    this.resultsSlideIndex = this.slides.length - 1;
    this.firstQuestionIndex = 1;

    const dataEl = section.querySelector(`#IfQuizData-${this.sectionId}`);
    this.config = dataEl ? JSON.parse(dataEl.textContent) : { products: [], productsToShow: 8 };
    this.products = this.config.products || [];
    this.answers = {};
    this.currentSlide = 0;
    this.quizCompleted = false;
    this.maxReachedSlide = 0;
    this.autoOpenScheduled = false;
    this.autoOpenTimer = null;
    this.ageGateObserver = null;
    this.ageGatePoll = null;
    this.ageGateStopTimer = null;
    this.ageGateInitialTimer = null;

    this.excludedTypes = ['LUBRICANTS', 'TOY CLEANER', 'CONFIDENCE ENHANCERS'];

    this.categoryMap = {
      vibrators: {
        types: [
          'BULLET VIBRATOR',
          'CLITORAL STIMULATOR',
          'RABBIT VIBRATOR',
          'WAND VIBRATOR',
          'G-SPOT STITULATORS',
          'BEAD'
        ],
        tags: [
          'cat-feel-good-vibrators',
          'cat-comfort-stimulation',
          'sub-wand-vibrator',
          'sub-bullet-vibrator',
          'sub-clitoral-stimulator',
          'sub-rabbit-vibrator',
          'sub-g-spot-stitulators'
        ]
      },
      solo: {
        types: ['SOLO- MASTURBATOR', 'PROSTATE', 'LEARN CONTROL- PENIS PUMP', 'PENIS EXTENDER'],
        tags: ['cat-solo-masturbator', 'sub-solo-masturbator', 'sub-prostate', 'cat-learn-control-penis-pump', 'him']
      },
      couples: {
        types: ['COUPLE VIBRATOR'],
        tags: ['cat-couples-connection', 'sub-couple-vibrator', 'couples', 'connection']
      },
      dildos: {
        types: ['REALISTIC DILDO', 'HUGE DILDO', 'VIBRATING DILDO', 'GLASS DILDO', 'ADVENTURE & PLAY'],
        tags: ['cat-explore-dildo', 'sub-realistic-dildo', 'sub-huge-dildo', 'sub-vibrating-dildo', 'sub-glass-dildo']
      }
    };

    this.experienceMap = {
      newbie: {
        types: ['BULLET VIBRATOR', 'CLITORAL STIMULATOR', 'BEAD'],
        tags: ['comfort', 'start low', 'go slow']
      },
      tried: {
        types: [
          'RABBIT VIBRATOR',
          'WAND VIBRATOR',
          'REALISTIC DILDO',
          'G-SPOT STITULATORS',
          'VIBRATING DILDO',
          'SOLO- MASTURBATOR',
          'GLASS DILDO'
        ],
        tags: ['confidence', 'curiosity']
      },
      pro: {
        types: [
          'PROSTATE',
          'ADVENTURE & PLAY',
          'HUGE DILDO',
          'LEARN CONTROL- PENIS PUMP',
          'PENIS EXTENDER',
          'COUPLE VIBRATOR'
        ],
        tags: ['control']
      }
    };

    this.bindEvents();
    this.showSlide(0);
    this.scheduleAutoOpen();
  }

  isAgeGateBlocking() {
    const root = document.getElementById('agp__root');
    if (!root) return false;
    if (root.hidden) return false;
    if (root.getAttribute('aria-hidden') === 'true') return false;

    const style = window.getComputedStyle(root);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }

    const rect = root.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  cleanupAgeGateWatchers() {
    if (this.ageGateObserver) {
      this.ageGateObserver.disconnect();
      this.ageGateObserver = null;
    }

    if (this.ageGatePoll) {
      window.clearInterval(this.ageGatePoll);
      this.ageGatePoll = null;
    }

    if (this.ageGateStopTimer) {
      window.clearTimeout(this.ageGateStopTimer);
      this.ageGateStopTimer = null;
    }

    if (this.ageGateInitialTimer) {
      window.clearTimeout(this.ageGateInitialTimer);
      this.ageGateInitialTimer = null;
    }
  }

  static autoOpenStorageKey = 'if-quiz-auto-shown';

  hasAutoOpenBeenShown() {
    try {
      return localStorage.getItem(IfQuiz.autoOpenStorageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  markAutoOpenShown() {
    try {
      localStorage.setItem(IfQuiz.autoOpenStorageKey, '1');
    } catch (error) {
      /* ignore storage errors */
    }
  }

  markAutoOpenDismissed() {
    this.markAutoOpenShown();

    if (this.autoOpenTimer) {
      window.clearTimeout(this.autoOpenTimer);
      this.autoOpenTimer = null;
    }

    this.cleanupAgeGateWatchers();
  }

  scheduleAutoOpen() {
    if (!this.config.autoOpen) return;
    if (window.Shopify?.designMode) return;
    if (this.hasAutoOpenBeenShown()) return;

    const delay = Number(this.config.autoOpenDelay) || 4000;
    let gateWasVisible = false;
    let initialCheckDone = false;

    const openAfterDelay = () => {
      if (this.autoOpenScheduled) return;
      if (this.isAgeGateBlocking()) return;
      if (this.popup?.classList.contains('active')) return;
      if (this.hasAutoOpenBeenShown()) return;

      this.autoOpenScheduled = true;
      this.cleanupAgeGateWatchers();

      this.autoOpenTimer = window.setTimeout(() => {
        if (this.isAgeGateBlocking()) return;
        if (this.popup?.classList.contains('active')) return;
        if (this.hasAutoOpenBeenShown()) return;

        this.markAutoOpenShown();
        this.openPopup(0);
      }, delay);
    };

    const onAgeGateChange = () => {
      if (this.isAgeGateBlocking()) {
        gateWasVisible = true;
        return;
      }

      if (gateWasVisible || initialCheckDone) {
        openAfterDelay();
      }
    };

    this.ageGateObserver = new MutationObserver(onAgeGateChange);
    this.ageGateObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
    });

    this.ageGatePoll = window.setInterval(onAgeGateChange, 250);
    this.ageGateStopTimer = window.setTimeout(() => this.cleanupAgeGateWatchers(), 120000);

    this.ageGateInitialTimer = window.setTimeout(() => {
      initialCheckDone = true;
      if (!gateWasVisible && !this.isAgeGateBlocking()) {
        openAfterDelay();
      }
    }, 800);

    onAgeGateChange();
  }

  bindEvents() {
    this.openTriggers.forEach((button) => {
      button.addEventListener('click', () => this.openPopup());
    });

    if (this.startBtn) {
      this.startBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.openPopup(this.firstQuestionIndex);
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.handleClose());
    }

    this.section.querySelectorAll('.if-quiz-option').forEach((button) => {
      button.addEventListener('click', () => this.handleOptionClick(button));
    });

    this.section.querySelectorAll('.if-back-btn').forEach((button) => {
      button.addEventListener('click', () => {
        if (this.currentSlide === this.resultsSlideIndex) {
          this.showSlide(4);
          return;
        }
        if (this.currentSlide > this.firstQuestionIndex) {
          this.showSlide(this.currentSlide - 1);
        } else if (this.currentSlide === this.firstQuestionIndex) {
          this.showSlide(0);
        }
      });
    });

    this.section.querySelectorAll('.if-skip-button').forEach((button) => {
      button.addEventListener('click', () => this.handleSkip());
    });

    this.resultsScroll?.addEventListener('click', (event) => {
      const addBtn = event.target.closest('.if-quiz-pick-add-cart');
      if (addBtn) {
        event.preventDefault();
        event.stopPropagation();
        this.handleAddToCart(addBtn);
        return;
      }

      if (event.target.closest('.if-quiz-pick-details')) {
        return;
      }

      const pick = event.target.closest('.if-quiz-result-pick');
      if (!pick) return;
      const index = Number(pick.dataset.productIndex);
      if (!Number.isNaN(index)) {
        this.setFeaturedProduct(index);
      }
    });

    this.resultsFeatured?.addEventListener('click', (event) => {
      const retakeBtn = event.target.closest('.if-quiz-retake-btn');
      if (retakeBtn) {
        this.handleRetake();
        return;
      }

      const addBtn = event.target.closest('.if-quiz-add-cart-btn');
      if (addBtn) {
        this.handleAddToCart(addBtn);
      }
    });
  }

  openPopup(startIndex) {
    if (this.autoOpenTimer) {
      window.clearTimeout(this.autoOpenTimer);
      this.autoOpenTimer = null;
    }

    this.popup.classList.add('active');
    document.body.classList.add('if-quiz-open');

    if (typeof startIndex === 'number') {
      this.showSlide(startIndex);
      return;
    }

    this.showSlide(this.quizCompleted ? this.resultsSlideIndex : 0);
  }

  handleOptionClick(button) {
    const question = button.dataset.question;
    const value = button.dataset.value;

    if (question && value) {
      this.answers[question] = value;
    }

    button.closest('.if-quiz-options')?.querySelectorAll('.if-quiz-option').forEach((option) => {
      option.classList.remove('is-selected');
    });
    button.classList.add('is-selected');

    const step = Number(button.closest('.if-quiz-inner-slide-main')?.dataset.step || 0);

    if (step === 4) {
      this.quizCompleted = true;
      this.renderResults();
      this.showSlide(this.resultsSlideIndex);
      return;
    }

    this.showSlide(this.currentSlide + 1);
  }

  handleSkip() {
    this.markAutoOpenDismissed();
    this.resetQuiz();
    this.closePopup();
    this.showSlide(0);
  }

  handleRetake() {
    this.resetQuiz();
    this.showSlide(this.firstQuestionIndex);
  }

  resetQuiz() {
    this.answers = {};
    this.quizCompleted = false;
    this.maxReachedSlide = 0;
    this.section.querySelectorAll('.if-quiz-option').forEach((option) => {
      option.classList.remove('is-selected');
    });
  }

  handleClose() {
    if (this.quizCompleted) {
      this.closePopup();
      return;
    }
    this.handleSkip();
  }

  closePopup() {
    this.popup.classList.remove('active');
    document.body.classList.remove('if-quiz-open');
    this.popup?.classList.remove('if-quiz-popup--results');
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      slide.style.display = i === index ? 'flex' : 'none';
    });
    this.currentSlide = index;
    this.maxReachedSlide = Math.max(this.maxReachedSlide || 0, index);

    if (this.topbarBack) {
      this.topbarBack.hidden = index === 0;
    }

    this.updateStepIndicators(index);
    this.popup?.classList.toggle('if-quiz-popup--results', index === this.resultsSlideIndex);
  }

  updateStepIndicators(activeIndex) {
    this.section.querySelectorAll('.if-quiz-step-container').forEach((container) => {
      const step = Number(container.dataset.step || 0);
      const isQuestionSlide = activeIndex >= this.firstQuestionIndex && activeIndex <= 4;

      container.querySelectorAll('.if-quiz-num').forEach((numButton, index) => {
        numButton.classList.toggle('is-active', isQuestionSlide && step === activeIndex && index === activeIndex - 1);
        numButton.classList.toggle('is-complete', isQuestionSlide && step === activeIndex && index < activeIndex - 1);
      });
    });
  }

  normalizeTags(tags) {
    if (Array.isArray(tags)) {
      return tags.map((tag) => String(tag).toLowerCase().trim());
    }
    if (typeof tags === 'string') {
      return tags.split(',').map((tag) => tag.toLowerCase().trim());
    }
    return [];
  }

  hasAnyTag(tags, keys) {
    return keys.some((key) => tags.includes(key));
  }

  matchesAudience(tags) {
    if (this.answers.audience === 'her') {
      return this.hasAnyTag(tags, ['her', 'both']);
    }
    if (this.answers.audience === 'him') {
      return this.hasAnyTag(tags, ['him', 'both']);
    }
    if (this.answers.audience === 'both') {
      return this.hasAnyTag(tags, ['both', 'her', 'him', 'couples']);
    }
    return true;
  }

  scoreProduct(product) {
    const tags = this.normalizeTags(product.tags);
    const type = (product.type || '').toUpperCase().trim();
    let score = 1;

    if (this.excludedTypes.includes(type)) {
      return -1;
    }

    if (!this.matchesAudience(tags)) {
      return -1;
    }

    if (this.answers.usage === 'partner') {
      if (!this.hasAnyTag(tags, ['couples', 'connection']) && type !== 'COUPLE VIBRATOR') {
        return -1;
      }
      score += 5;
    }

    if (this.answers.usage === 'solo' && type === 'COUPLE VIBRATOR') {
      return -1;
    }

    const experience = this.experienceMap[this.answers.experience];
    if (experience) {
      if (experience.types.includes(type)) score += 4;
      if (this.hasAnyTag(tags, experience.tags)) score += 2;
    }

    const category = this.categoryMap[this.answers.category];
    if (category) {
      if (category.types.includes(type)) score += 8;
      if (this.hasAnyTag(tags, category.tags)) score += 5;
    } else if (this.answers.category) {
      return -1;
    }

    if (this.answers.audience === 'her' && tags.includes('her')) score += 4;
    if (this.answers.audience === 'him' && tags.includes('him')) score += 4;
    if (this.answers.audience === 'both' && tags.includes('both')) score += 4;

    if (this.answers.usage === 'solo' && type === 'SOLO- MASTURBATOR') score += 4;
    if (this.answers.usage === 'partner' && tags.includes('couples')) score += 3;

    if (this.answers.audience === 'him' && type === 'PROSTATE') score += 3;
    if (
      this.answers.audience === 'her' &&
      ['CLITORAL STIMULATOR', 'RABBIT VIBRATOR', 'BULLET VIBRATOR', 'G-SPOT STITULATORS'].includes(type)
    ) {
      score += 3;
    }

    return score;
  }

  getMatchedProducts(limit) {
    const max = limit || this.config.productsToShow;
    const scored = this.products
      .map((product) => ({ product, score: this.scoreProduct(product) }))
      .filter((entry) => entry.score >= 0)
      .sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title));

    if (scored.length === 0) {
      return this.products
        .filter((product) => !this.excludedTypes.includes((product.type || '').toUpperCase().trim()))
        .slice(0, max);
    }

    return scored.slice(0, max).map((entry) => entry.product);
  }

  formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, this.config.moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  formatProductType(type) {
    if (!type) return 'Recommended';
    return type
      .toLowerCase()
      .replace(/\s*-\s*/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  getShortTitle(title) {
    return title.split('|')[0].trim();
  }

  buildRecommendationPick(product, index, isActive) {
    const label = this.escapeHtml(this.formatProductType(product.type));
    const title = this.escapeHtml(this.getShortTitle(product.title));
    const image = product.image || '';
    const addLabel = product.available === false ? 'Sold out' : 'Add to cart';

    return `
      <article
        class="if-quiz-result-pick${isActive ? ' is-active' : ''}"
        data-product-index="${index}"
        role="listitem"
      >
        <span class="if-quiz-result-pick__label">${label}</span>
        <div class="if-quiz-result-pick__media">
          ${image ? `<img src="${image}" alt="${title}" loading="lazy" width="400" height="500">` : ''}
          <div class="if-quiz-result-pick__overlay">
            <h4 class="if-quiz-result-pick__overlay-title">${title}</h4>
            <p class="if-quiz-result-pick__overlay-type">${label}</p>
            <div class="if-quiz-result-pick__overlay-actions">
              <button
                type="button"
                class="if-quiz-pick-add-cart"
                data-variant-id="${product.variantId}"
                ${product.available === false ? 'disabled' : ''}
              >${addLabel}</button>
              <a href="${product.url}" class="if-quiz-pick-details">See details</a>
            </div>
          </div>
        </div>
      </article>
    `;
  }

  buildFeaturedProduct(product) {
    const title = this.escapeHtml(this.getShortTitle(product.title));
    const intro = this.escapeHtml(this.config.resultsIntro || 'Meet');
    const description = this.escapeHtml(product.description || '');
    const image = product.image || '';
    const price = this.formatMoney(product.price);
    const addLabel = product.available === false ? 'Sold out' : 'Add to cart';

    return `
      <div class="if-quiz-result-featured">
        <div class="if-quiz-result-featured__media">
          ${image ? `<img src="${image}" alt="${title}" loading="lazy" width="800" height="800">` : ''}
        </div>
        <div class="if-quiz-result-featured__panel">
          <h3 class="if-quiz-result-featured__title">${intro} ${title}</h3>
          <p class="if-quiz-result-featured__text">${description}</p>
          <p class="if-quiz-result-featured__price">${price}</p>
          <div class="if-quiz-result-featured__actions">
            <button
              type="button"
              class="if-quiz-add-cart-btn"
              data-variant-id="${product.variantId}"
              ${product.available === false ? 'disabled' : ''}
            >${addLabel}</button>
            <a href="${product.url}" class="if-quiz-details-btn">See details</a>
          </div>
          <button type="button" class="if-quiz-retake-btn">
            <span aria-hidden="true">↻</span> Retake quiz
          </button>
        </div>
      </div>
    `;
  }

  setFeaturedProduct(index) {
    const product = this.matchedProducts[index];
    if (!product || !this.resultsFeatured) return;

    this.resultsFeatured.innerHTML = this.buildFeaturedProduct(product);

    this.resultsScroll?.querySelectorAll('.if-quiz-result-pick').forEach((pick, pickIndex) => {
      pick.classList.toggle('is-active', pickIndex === index);
    });
  }

  async handleAddToCart(button) {
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.disabled) return;

    const defaultLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      button.textContent = 'Added to cart';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      button.textContent = 'Try again';
      button.disabled = false;
      return;
    }

    window.setTimeout(() => {
      button.textContent = defaultLabel;
      button.disabled = false;
    }, 2000);
  }

  renderResults() {
    this.matchedProducts = this.getMatchedProducts(this.config.productsToShow);

    if (!this.resultsScroll || !this.resultsFeatured) return;

    if (!this.matchedProducts.length) {
      this.resultsScroll.innerHTML = '';
      this.resultsFeatured.innerHTML = '<p class="if-quiz-empty-note">No matching products found.</p>';
      return;
    }

    this.resultsScroll.innerHTML = this.matchedProducts
      .map((product, index) => this.buildRecommendationPick(product, index, index === 0))
      .join('');

    this.setFeaturedProduct(0);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.if-quiz-section').forEach((section) => {
    new IfQuiz(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.if-quiz-section') || event.target.closest('.if-quiz-section');
  if (section) {
    new IfQuiz(section);
  }
});
